import { Descriptions } from "antd";
import { I18N_NS } from "Config/i18n";
import React from "react";
import { useTranslation } from "react-i18next";

interface BCFViewerTopicInfoProps {
  topic: API_BcfTopic;
}

export const BCFViewerTopicInfo: React.FC<BCFViewerTopicInfoProps> = ({ topic }) => {
  const { t } = useTranslation(I18N_NS.PROJECT);
  const { title, creationDate, topicStatus, topicType, priority, viewpoints, description } = topic;

  return topic ? (
    <>
      <Descriptions bordered layout="vertical" className="mb-2">
        <Descriptions.Item label={t("Name")}>{title}</Descriptions.Item>
        <Descriptions.Item label={t("Created")}>{creationDate}</Descriptions.Item>
        <Descriptions.Item label={t("Status")}>{topicStatus}</Descriptions.Item>
        <Descriptions.Item label={t("Type")}>{topicType}</Descriptions.Item>
        <Descriptions.Item label={t("Priority")}>{priority}</Descriptions.Item>
        <Descriptions.Item label={t("Description")}>{description}</Descriptions.Item>
      </Descriptions>
      {viewpoints && viewpoints.length
        ? viewpoints.map((vp, idx) => (
            <div className="fullWidth" key={idx}>
              <img src={`data:image/png;base64,${vp.snapshotBufferedImage}`} alt={title} className="fullWidth" />
            </div>
          ))
        : null}
    </>
  ) : null;
};
